import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Page404 from "./views/404";

Vue.use(Router);

export default new Router({
  mode: "history",
  linkExactActiveClass: "active",
  routes: [
    {
      path: "/",
      name: "Home",
      components: {
        header: AppHeader,
        default: () => import("./views/Home"),
        footer: AppFooter,
      },
    },
    {
      path: "/404",
      name: "404",
      meta: { isPublic: true },
      component: Page404,
      alias: "*",
    },
    {
      path: "/contact-us",
      name: "Contact Us",
      components: {
        header: AppHeader,
        default: () => import('./views/ContactUs'),
        footer: AppFooter
      }
    },
    {
      path: '/pre-cast-fence',
      name: 'Pre-cast Fence',
      components: {
        header: AppHeader,
        default: () => import('./views/PrecastFence'),
        footer: AppFooter
      }
    },
    {
      path: "/about-us",
      name: "About Us",
      components: {
        header: AppHeader,
        default: () => import("./views/AboutUs"),
        footer: AppFooter,
      },
    },
    {
      path: "/our-products",
      name: "Our-Products",
      components: {
        header: AppHeader,
        default: () => import("./views/OurProducts"),
        footer: AppFooter,
      },
    },

    {
      path: "/our-projects",
      name: "Our-Projects",
      components: {
        header: AppHeader,
        default: () => import("./views/OurProjects"),
        footer: AppFooter,
      },
    },
    {
      path: "/hybrid-chb",
      name: "Hybrid CHB",
      components: {
        header: AppHeader,
        default: () => import("./views/HybridChb"),
        footer: AppFooter,
      },
    },
    {
      path: "/project-sites",
      name: "Project Sites",
      components: {
        header: AppHeader,
        default: () => import("./views/ProjectSites"),
        footer: AppFooter,
      },
    }
  ],
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});
